import { Typography, useTheme } from '@mui/material';
import { memo } from 'react';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import FormSection from '@shared/components/FormSection';
import StyledTextField from '@shared/components/StyledTextField';

const ContactInfo = ({ formik }) => {
  const theme = useTheme();

  return (
    <FormSection title="Datos de contacto" customLayout={{ xs: { 1: 12 } }}>
      <Typography
        sx={{ marginBottom: 2, fontSize: '14px', color: theme.textGray }}
      >
        Los datos que nos brindes serán fundamental para que gestiones tu
        reserva y recibas información importante sobre tu viaje.
      </Typography>

      {/* Email */}
      <StyledTextField
        name="contact.email"
        label={
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <MailOutlineIcon sx={{ color: theme.tertiary }} />
            <span style={{ marginLeft: '1vw' }}>E-mail</span>
          </span>
        }
        formik={formik}
        fullWidth
      />

      {/* Repetir Email */}
      <StyledTextField
        name="contact.repeatEmail"
        label={
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <MailOutlineIcon sx={{ color: theme.tertiary }} />
            <span style={{ marginLeft: '1vw' }}>Confirme E-mail</span>
          </span>
        }
        formik={formik}
        fullWidth
      />
    </FormSection>
  );
};

export default memo(ContactInfo);
